export const AGREE_TOS = "AGREE_TOS";
